export default function makeid(length) {
  if (!globalThis.crypto?.getRandomValues) {
    throw new Error("Secure random generator unavailable");
  }

  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  const randomValues = new Uint32Array(length);

  globalThis.crypto.getRandomValues(randomValues);

  return Array.from(randomValues)
    .map((v) => chars[v % chars.length])
    .join("");
}